export const scrollarParaOElemento = (elemento: HTMLElement | undefined | null) => {
  window.scrollTo(0,
    window.scrollY +
    (elemento?.getBoundingClientRect().top ?? 0) -
    (document.querySelector("header")?.getBoundingClientRect().height ?? 0)
  )
}